import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isTelegramApp: false,
    telegramUser: null,
    isReady: false,
    telegramTheme: null
};

const telegramSlice = createSlice({
    name: 'telegram',
    initialState,
    reducers: {
        setTelegramApp: (state, action) => {
            state.isTelegramApp = action.payload.isTelegramApp;
            state.telegramUser = action.payload.telegramUser;
            state.isReady = action.payload.isReady;
            state.telegramTheme = action.payload.telegramTheme;
        },
        setTelegramUser: (state, action) => {
            state.telegramUser = action.payload;
        },
        setTelegramReady: (state, action) => {
            state.isReady = action.payload;
        },
        setTelegramTheme: (state, action) => {
            state.telegramTheme = action.payload;
        },
        resetTelegram: (state) => {
            state.isTelegramApp = false;
            state.telegramUser = null;
            state.isReady = false;
            state.telegramTheme = null;
        }
    }
});

export const { setTelegramApp, setTelegramUser, setTelegramReady, setTelegramTheme, resetTelegram } = telegramSlice.actions;
export default telegramSlice.reducer; 